const ConditionalWrapper = props => {
    if (!props.children) return null
    if (Array.isArray(props.wrapper))
        return props.condition ? props.wrapper[0](props.children) : props.wrapper[1](props.children)
    return props.condition ? props.wrapper(props.children) : props.children
}

export default ConditionalWrapper
